
import dtime from 'time-formater';
const workTime = {startTime: 9,endTime: 21};
const springWorkTime = {startTime: 9,endTime: 18};
const springFestivalTime = {startTime: '2018/2/8 21:00', endTime: '2018/2/21 21:00'};

const d11Rang = {
	'11/10':[
		{startTime: 9,endTime: 24}
	],
	'11/11':[
		{startTime: 0,endTime: 2},
		{startTime: 9,endTime: 24}
	]
};


let timeDiff = 0;

function getMonthDateStr() {
	let now = (new Date());
	return `${now.getMonth()+1}/${now.getDate()}`;
}

function getServerDate(){
	let xhr = null;
  
	if (window.XMLHttpRequest){
		xhr = new window.XMLHttpRequest();
	} else { // ie
		xhr = new ActiveObject("Microsoft");
	}

	xhr.open("GET","/",false);//false不可变
	xhr.send(null);
	let date = xhr.getResponseHeader("Date");
  
	return new Date(date);
}

export function ajustTime() {
	const serviceTime = +getServerDate();
	const localTime = +(new Date());

	const diff = serviceTime - localTime;

	console.log('与服务器相差', diff);
	console.log(serviceTime);


  	// 允许 5000 ms 的差异
	if (diff > 0 && Math.abs(diff) > 5000) {
		timeDiff = serviceTime - localTime;
	}
}

function getDateTime() {
	return +(new Date()) + timeDiff;
}

function isInWork(work) {
	const dt = dtime(new Date(getDateTime()));
	const hour = +dt.format('H');
	
	if (hour < work.startTime) {
		return false;
	}

	if (hour >= work.endTime) {
		return false;
	}

	return true;
}

function isInDouble11Work(works){
	let inWorkTime = false;
	if(Array.isArray(works)){
		for(let i=0;i<works.length;i++){
			if(!inWorkTime){
				inWorkTime = isInWork(works[i]);
			}
			
		}
	}
	return inWorkTime;
}

export function isWorkTime() {
	return isInWork(workTime);
}
export function isDouble11WorkTime(){
	let d11workTime = getDouble11WorkTime();
	if ( d11workTime) {
		return isInDouble11Work(d11workTime);
	}
	return true;
}

export function isDouble11(){
	let d11workTime = getDouble11WorkTime();
	if ( d11workTime) {
		return true;
	}
	return false;
}

export function isSpringWorkTime() {
	if (isSpringFestival()) {
		return isInWork(springWorkTime);
	}

	return true;
}

export function isSpringFestival() {
	const n = getDateTime();
	const s = +(new Date(springFestivalTime.startTime));
	const e = +(new Date(springFestivalTime.endTime));

	return (n>=s && n <= e);
}
export function getDouble11WorkTime(){

	const n = getMonthDateStr();

	return d11Rang[n];
}


/** WEBPACK FOOTER **
 ** ./lib/work-time.js
 **/